// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__LuG6x","resendInfoText":"OnGoingPaymentBox_resendInfoText__2QIOr"};